
  // --- Filters ---

  // - Size of selects

  function resizeFilterSelects (filtersParent) {
    if (filtersParent.find('.filters-selects-list').length > 0 && ! filtersParent.find('.filters-selects-list').hasClass('row')) {
      if ($(window).width() > 767) {
        //filtersParent.find('.filters-selects-list .filters-selects-box, .filters-selects-list .selectyummy').width(100 / filtersParent.find('.filters-selects-list select').length + '%')
        // not required
      } else {
        //filtersParent.find('.filters-selects-list .filters-selects-box, .filters-selects-list .selectyummy').width('100%')
          // not required
      }
    }
  }

  $(window).resize(function(){
    $('.filters').each(function(){
      resizeFilterSelects($(this))
    })
  })

  $('.filters').each(function(){
    resizeFilterSelects($(this))
  })

  // - Limit boxes

  var maxBoxes

  $('.filters').each(function(){
    maxBoxes = $(this).attr('data-max')
    $(this).find('.filters-next-number, .filters-max').text(maxBoxes)

    // -- Collapse boxes
    $(this).find('.filters-content .filter-box').addClass('collapsed tag-active').slideUp(0)
    $(this).find('.filters-content .filter-box').slice(0, maxBoxes).removeClass('collapsed').slideDown()

    // -- Tables need inner divs to be slided properly
    if ($(this).find('.filter-box.collapsed').find('.table-td').length > 0) {
      $(this).find('.filter-box.collapsed .table-td div').slideUp(0)
    }
  })

  // Filter function

  function filterElements (filtersParent) {
    // Get proper boxes

    if (filtersParent.parents('.section--jobsearch-content').length <= 0) {
      var myTag = 0,
          myDate = 0

      if (filtersParent.find('.filters-nav').length > 0) {
        myTag = filtersParent.find('.filters-nav li.active').attr('data-filter')
      }

      if (filtersParent.find('.newsroom-filter-date').length > 0) {
        myDate = filtersParent.find('.newsroom-filter-date').val()
      }

      if (myTag == 0 && myDate == 0) {
        filtersParent.find('.filters-content .filter-box').removeClass('tag-hidden').addClass('tag-active')
      } else {
        filtersParent.find('.filters-content .filter-box').each(function(){
          var tagTrue = false,
              dateTrue = false
          if (myTag == 0 || $(this).attr('data-filter') == myTag) {
            tagTrue = true
          }
          if (myDate == 0 || $(this).attr('data-date') == myDate) {
            dateTrue = true
          }
          if (tagTrue && dateTrue){
            $(this).addClass('tag-active')
          } else {
            $(this).removeClass('tag-active')
          }
        })
      }
    }

    // Show proper boxes

    var hiddenL = filtersParent.find('.filters-content .filter-box.tag-active').length

    // - Vertical list: boxes slide up and down

    if (filtersParent.hasClass('filters--vertical')) {
      filtersParent.find('.filters-content .filter-box.tag-active').slice(0, maxBoxes).removeClass('tag-hidden collapsed').slideDown()
      filtersParent.find('.filters-content .filter-box.tag-active').slice(maxBoxes, hiddenL).addClass('collapsed').slideUp()
      filtersParent.find('.filters-content .filter-box:not(.tag-active)').addClass('tag-hidden').slideUp()

    // - Horizontal list: boxes fade out and in

    } else if (filtersParent.hasClass('filters--horizontal')) {
      filtersParent.find('.filters-content').fadeOut(function(){
        filtersParent.find('.filters-content .filter-box.tag-active').slice(0, maxBoxes).removeClass('tag-hidden collapsed').show()
        filtersParent.find('.filters-content .filter-box.tag-active').slice(maxBoxes, hiddenL).addClass('collapsed').hide()
        filtersParent.find('.filters-content .filter-box:not(.tag-active)').addClass('tag-hidden').hide()
        filtersParent.find('.filters-content').fadeIn()
      })

    // - Table list: rows slide up and down

    } else {
      filtersParent.find('.filters-content .filter-box.tag-active').slice(0, maxBoxes).removeClass('tag-hidden collapsed').slideDown()
      filtersParent.find('.filters-content .filter-box.tag-active').slice(0, maxBoxes).find('.table-td div').slideDown()
      filtersParent.find('.filters-content .filter-box.tag-active').slice(maxBoxes, hiddenL).addClass('collapsed').slideUp()
      filtersParent.find('.filters-content .filter-box:not(.tag-active)').addClass('tag-hidden').slideUp()
      filtersParent.find('.filters-content .filter-box.tag-hidden, .filters-content .filter-box:not(.tag-active)').find('.table-td div').slideUp()
    }
  }

  // Filter by filter tag

  $('.filters-nav li a').click(function(e){
	if( $(this).parents('.research-archive-filter').length ) {
      return;
    }
    e.preventDefault()
    var pos = 0,
        filterList = $(this).parents('.filters-nav-outer').find('.filters-nav'),
        filterWindow = $(this).parents('.filters-nav-outer').find('.filters-nav-window'),
        filtersParent = $(this).parents('.filters')
    filterList.find('li').removeClass('active')
    $(this).parent().addClass('active')
    pos = $(this).parent().position().left - 16
    filterWindow.stop().animate({ scrollLeft: "+=" + pos }, 300)

    // Change select2 value (do not touch the basic select!)
    filtersParent.find('.filter-nav-select option[value="' + $(this).parent().attr('data-filter') + '"]').attr('selected', true)
    filtersParent.find('.filter-nav-select').trigger('change.select2')

    filterElements(filtersParent)
  })

  $('.filter-nav-select').change(function(){
    var filtersParent = $(this).parents('.filters')
    filtersParent.find('.filters-nav li[data-filter="'+ $(this).val() +'"] a').click()
  })

  // Filter by select

  $('.filters-selects-list select:not(.nonfilter)').change(function(){
    var filtersParent = $(this).parents('.filters')

    // Add tags

    var template = '<span class="filters-tag"> \
      <button class="filters-tag-remove" aria-label="close"><i class="icon-close" aria-hidden="true"></i></button> \
      <span></span> \
    </span>'
    if ($(this).attr('multiple')) {
      filtersParent.find('.filters-tags-list .filters-tag[data-filter='+ $(this).attr('data-filter-select') +']').remove()
      for (var i = 0; i < $(this).val().length; ++i) {
        let temp = $( template );

        let filteredButton = $(temp).find('span');
        let theTagText = $(this).children( 'option[value="' + $(this).val()[i] + '"]' ).text();
        theTagText = theTagText.replace(/\(\d+\)/g, '');

        filteredButton.text( theTagText );
        
        filteredButton.attr( 'data-value', $(this).val()[i] );

        $( temp ).attr( 'data-filter', $( this ).attr( 'data-filter-select' ) );

        // NOTE: Ignoring this as it is previous added code, so I don't want to conflicts at the moment.
        filtersParent.find( '.filters-tags-list' ).append( $( temp ) ); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append
      }
    } else {
      var temp = $( template );

      let filteredButton = $(temp).find('span');

      filteredButton.text( $(this).children( 'option[value="' + $(this).val() + '"]' ).text() );
      filteredButton.attr( 'data-value', $(this).val() );

      $( temp ).attr( 'data-filter', $( this ).attr( 'data-filter-select' ) );

      // NOTE: Ignoring this as it is previous added code, so I don't want to conflicts at the moment.
      filtersParent.find( '.filters-tags-list' ).append( $( temp ) ); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append
    }

    // Filter
    filterElements( filtersParent );

    // Show clear button
    if(filtersParent.find('.filters-tag') && filtersParent.find('input[name=date-from]') && filtersParent.find('input[name=date-to]')){
      if (filtersParent.find('.filters-tag').length > 0 || filtersParent.find('input[name=date-from]').val() || filtersParent.find('input[name=date-to]').val() ){
        filtersParent.find('.filters-clear').show()
      }
    }
    // Click tag remove

    $(document).on('click','.filters-tag-remove',function(){
      var myParent = $(this).parents('.filters-tag'),
          mySelect = $('.filters-selects-list select[data-filter-select="'+myParent.attr('data-filter')+'"]')
          filterInputId = $(this).parents('.filters-tag').attr('data-filter');
          filterInputFld = $('#'+filterInputId);
          var post_type = $('.filters-content').attr('data-type');
          mySelect.find('option[value="'+myParent.find('span').data( 'value' )+'"]').prop('selected', false);
          filterInputFld.val('');
          filterInputFld.trigger('change');
          mySelect.change()
          myParent.remove()
          if ( (post_type === 'employee-testimonial') ) {
            if ( $('.filters-tags-list').is(':empty') ) {
              window.location.reload();  
            }
          }
    })
    if ( filtersParent.find('.filters-tag').length == 0 ) {
        if(filtersParent.find('input[name=date-from]').val() == undefined){
            filtersParent.find('.filters-clear').hide()
        }
        if (filtersParent.find('input[name=date-from]').val() == '' && filtersParent.find('input[name=date-to]').val() == '') {
          filtersParent.find('.filters-clear').hide()
       }
    }
  }).change()

  // Click clear button

  $('.filters-clear').click(function(e){
    e.preventDefault()
    var post_type = $('.filters-content').attr('data-type');
    var filtersParent = $(this).parents('.filters')
    filtersParent.find('.filters-selects-list select:not(.ui-datepicker-month, .ui-datepicker-year)').val('').change()
    if( filtersParent.find('input[name=date-from]').length ) {
      filtersParent.find('input[name=date-from]').val('').change()
      filtersParent.find('input[name=date-to]').val('').change()
    }
    if( post_type === 'employee-testimonial' ) {
      window.location.reload();
    }
    filtersParent.find('.filters-tag').remove()
    $(this).hide()
  })
